import styled from 'styled-components'

export const ShopContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-bottom: 1em;
  .loadingIcon {
    margin-top: 6vw;
    font-size: 2vw;
    @media only screen and (max-width: 900px) {
      font-size: 6vw;
    }
  }
`;

export const title = styled.h1`
  font-size: 4vw;
  @media only screen and (max-width: 900px) {
    font-size: 9vw;
  }
  &.mobileVersion {
    font-size: 9vw;
  }
  line-height: 1em;
  margin-top: 2vw;
  margin-bottom: 2vw;
`;

export const shopItemsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3,1fr);
  grid-gap: 1vw;
  @media only screen and (max-width: 900px) {
    grid-template-columns: repeat(1,1fr);
    grid-gap: 8vw;
    margin-top: 8vw;
  }
  grid-auto-rows: min-content;
  align-items: flex-end;
  
`;

export const shopItemContainer = styled.div`
  position: relative;
  cursor: pointer;
  transition-duration: 1s;
  width: 30vw;
  max-height: 30vw;
  @media only screen and (max-width: 900px) {
    width: 90vw;
    max-height: 90vw;
  }
  overflow: hidden;

  &:hover {
    img {
      opacity: 0.8;
    }
  }

  img {
    opacity: 1;
    width: 100%;
    max-width: 30vw;
    @media only screen and (max-width: 900px) {
      max-width: 90vw;
    }
  }
`;

export const shopItemData = styled.div`
  display: flex;
  position: absolute;
  bottom: 0;
  padding: 0.3em;
  background-color: rgba(255, 255, 255, 0.3);
  width: 100%;
  > :first-child {
    flex-grow: 1;
  }
  > :last-child {
    text-align: right;
  }
`;

export const shopItemTitle = styled.h2`
  font-weight: bold;
  font-size: 1.3em;
`;
